import { blacklistQueryOptions } from '@/hooks/users/use-blacklist';
import { catchFetcherError } from '@/utils/fetcher';
import { queryClient } from '@/utils/query-client';

export function blacklistLoader() {
  return {
    promises: queryClient.ensureQueryData(blacklistQueryOptions).catch(catchFetcherError),
  };
}
